import * as Yup from 'yup'
import { createValidation, DocumentoType } from '../../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const empresaClienteSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    tipo: Yup.string().required('Tipo de documento é obrigatório'),
    cnpj: Yup.string()
      .nullable()
      .when('tipo', {
        is: (tipo: DocumentoType) => tipo === DocumentoType.Cnpj,
        then: Yup.string()
          .matches(/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/, 'CNPJ inválido')
          .required('O campo CNPJ obrigatório'),
        otherwise: Yup.string().notRequired(),
      }),
    cpf: Yup.string()
      .nullable()
      .when('tipo', {
        is: (tipo: DocumentoType) => tipo === DocumentoType.Cpf,
        then: Yup.string()
          .matches(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, 'CPF inválido')
          .required('O campo CPF obrigatório'),
        otherwise: Yup.string().notRequired(),
      }),
    caepf: Yup.string()
      .nullable()
      .when('tipo', {
        is: (tipo: DocumentoType) => tipo === DocumentoType.Caepf,
        then: Yup.string()
          .matches(/^\d{3}\.\d{3}\.\d{3}\/\d{3}-\d{2}$/, 'CAEPF inválido')
          .required('O campo CAEPF obrigatório'),
        otherwise: Yup.string().notRequired(),
      }),
    nome: Yup.string().trim().required(v.requiredField('input')),
    empresa: Yup.object().nullable().required(v.requiredField('empresa', 'select')),
  })
}
